import { forwardRef } from 'react';

import { Text, type TextProps } from '../Typography';
import { MarkdownCopyToClipboard } from './CopyToClipboardButton.js';
import type { ExtraProps } from './types.js';

type MarkdownTextProps = TextProps & ExtraProps & { copyControls: 'Visible' | 'Hidden' };

export const MarkdownText = forwardRef<HTMLParagraphElement, MarkdownTextProps>((props, ref) => {
  const { node, children, copyControls, ...rest } = props;
  return (
    <Text {...rest} ref={ref}>
      {children}
      <MarkdownCopyToClipboard content={children} mode={copyControls} />
    </Text>
  );
});
MarkdownText.displayName = 'MarkdownText';
